import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter, firstValueFrom, race, timer } from 'rxjs';

/** The longest the boot loader waits for the first route before giving up and showing the app anyway (ms). */
export const FIRST_ROUTE_CEILING_MS = 10_000;

/**
 * Resolves once the router's FIRST navigation has settled (end, cancel or error — the guards'
 * redirects included) and the browser has painted the result (two animation frames), or at the
 * ceiling. Used on the mobile app to keep the boot loader up until there is a page under it,
 * instead of uncovering an empty shell while the async guards still run.
 */
export async function firstRouteRendered(router: Router, ceilingMs = FIRST_ROUTE_CEILING_MS): Promise<void> {
  if (!router.navigated) {
    const settled = router.events.pipe(
      filter((e) => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError),
    );
    await firstValueFrom(race(settled, timer(ceilingMs)));
  }
  await new Promise<void>((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
}
